jQuery(document).ready(() => {

	// Input for some numbers
	///////////////////////////////////////////////////////////////////////////////////////////////
	
	const input_number = jQuery(`[data-form='input-number']`)

	input_number.each(function () {

		jQuery(this).on('input', () => {
			this.value = this.value.replace(/[^0-9]/g, '');
		});

	});

	// Input files
	///////////////////////////////////////////////////////////////////////////////////////////////

	const input_file = jQuery(`[data-form='input-file']`);

	input_file.each(function () {
		
		jQuery(this).on('change', (e) => {

		
			const file_name = jQuery(this)[0].files[0].name;	
			const file_to = jQuery(this).attr('data-form-to');
			const file_in = jQuery(`[data-form-in='${file_to}']`);

			file_in.text(file_name);

		});

	});

	// Input Focus
	///////////////////////////////////////////////////////////////////////////////////////////////

	const inputs_all = jQuery('.form__input-group');

	inputs_all.each(function () {

		const input = jQuery(this).children();

		input.focus(() => {

			jQuery(this).addClass('focus');
		});

		input.focusout(() => {

			jQuery(this).removeClass('focus');
		});

	});

	// Input Error
	///////////////////////////////////////////////////////////////////////////////////////////////

	// Show
	jQuery.fn.showInputError = function (options) {

		const config = jQuery.extend({
			msg: 'El campo es obligatorio'
		}, options);
		
		
		jQuery(this).each(function () {

			const container = jQuery(this).parent();
			container.append(`<span class="error">${config.msg}</span>`);
			container.addClass('error');

		});

	}

	// Update
	jQuery.fn.updateInputError = function (options) {

		const config = jQuery.extend({
			msg: 'El campo es obligatorio'
		}, options);


		jQuery(this).each(function () {

			const container = jQuery(this).parent();
			const span = container.children('.error');
			span.text(config.msg)
			container.addClass('error');

		});

	}

	// Hide
	jQuery.fn.hideInputError = function () {

		jQuery(this).each(function () {

			const container = jQuery(this).parent();
			const span = container.children('.error');
			span.hide();
			container.removeClass('error');

		});

	}


});